import {PaymentProvider} from "@irati/payments/enums/PaymentV2"

export default function paymentProviderForCountryCode() {
  // always adyen classic right now
  return PaymentProvider.Adyen
}
